import { render } from "./CustomersCreate.vue?vue&type=template&id=401b7cd4"
import script from "./CustomersCreate.vue?vue&type=script&lang=js"
export * from "./CustomersCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__